// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"7c6639b1","453":"1e87dc8c"}[chunkId] + ".chunk.js";
};